module.exports = __webpack_public_path__ + "static/media/keeperdao.09949be1.png";